import {
  PAGINATION_DEFAULT_LIMIT,
  WAREHOUSE_FILTERS_TYPE,
} from "../../utilities/constants";
import { paginationData } from "../../utilities/functions";
import { fetchApi } from "../fetchApi";

const fields = {
  "stock.picking.type": [
    "color",
    "code",
    "count_picking_ready",
    "count_picking_draft",
    "count_picking_waiting",
    "count_picking_late",
    "count_picking_backorders",
    "name",
    "warehouse_id",
  ],
  //tasklist
  "stock.picking": [
    "priority",
    "name",
    "location_id",
    "location_dest_id",
    "partner_id",
    "signature",
    "user_id",
    "scheduled_date",
    "date_deadline",
    "origin",
    "group_id",
    "backorder_id",
    "carrier_tracking_ref",
    "carrier_id",
    "weight",
    "shipping_weight",
    "picking_type_id",
    "company_id",
    "state",
    "activity_exception_decoration",
    "activity_exception_icon",
    "json_popover",
  ],
};

const getFields = (model) => fields[model] || [];

const getDomain = ({ search }) => {
  let domain = [];

  if (search?.picking_type_id) {
    if (search?.query || search.state) {
      domain.push("&");
    }
    // Filter by picking type ID
    domain.push(["picking_type_id", "=", search.picking_type_id]);
  }
  if (search.state) {
    domain = [...domain, ...WAREHOUSE_FILTERS_TYPE[search.state]];
  }
  if (search.query) {
    domain.push(
      "|",
      ["name", "ilike", search.query],
      ["origin", "ilike", search.query]
    );
  }
  // type filter is selected
  if (search.type) {
    const typeArray = JSON.parse(search.type);
    domain.push(typeArray);
    return domain;
  }
  return domain;
};


export async function warehouseSearchRead({
  model = "stock.picking.type",
  context,
  company_id,
  pagination = { limit: PAGINATION_DEFAULT_LIMIT, offset: 0 },
  search = { query: "", type: "" },
  sort = { type: "", dir: "asc" },
}) {
  const raw = JSON.stringify({
    jsonrpc: "2.0",
    method: "call",
    params: {
      model,
      domain: getDomain({ search }),
      fields: getFields(model),
      ...paginationData(pagination),
      sort: sort?.type ? `${sort?.type} ${sort?.dir}` : "",
      context: {
        lang: context.lang,
        tz: context.tz,
        uid: context.uid,
        allowed_company_ids: [company_id],
        default_type: "opportunity",
        search_default_assigned_to_me: 1,
        bin_size: true,
      },
    },
  });

  const requestOptions = {
    method: "POST",
    body: raw,
    redirect: "follow",
  };
  return fetchApi({ requestOptions, endpoint: `/web/dataset/search_read` });
}
